var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imc_err" },
    [
      _c(
        "b-alert",
        {
          attrs: {
            show: _vm.dismissCountDown,
            dismissible: "",
            variant: "danger",
          },
          on: {
            dismissed: function ($event) {
              _vm.dismissCountDown = 0
            },
            "dismiss-count-down": _vm.countDownChanged,
          },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.string_err))]),
          _vm._v(" "),
          _c("b-progress", {
            attrs: {
              variant: "warning",
              max: _vm.dismissSecs,
              value: _vm.dismissCountDown,
              height: "4px",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }